import React from "react";
import { Outlet } from "react-router-dom";
// __ __ Components/Helpers __ __ //
import Header from "../layout/Header/Header";
import Footer from "./Footer/Footer";

const Layout = () => {
    return (
        <>
            <Header />
            <Outlet />
            <Footer />
        </>
    );
};

export default Layout;
